import { deliveryMobx, storeMobx, buyTogetherMobx } from '@mobxStore'
import { confirmLayer, getHistoryNew, modalLayer, toast } from '@utils'
import { AddressEditModal, AddressTipModal } from '@cps'
import { TEEatType } from 'restaurant/mobx/store.mobx'
import { hasStoreModal } from 'components/modal/SelectAddress'

/** 验证地址状态 */
export enum TCheckAddressStatus {
  Success = 'success',
  Cancel = 'cancel',
  Skip = 'skip'
}

class DeliveryController {
  /**
   * type mall 商城 bt 拼单
   * form 来源是否是外卖过来的
   */
  static editAddressModal ({ address, callback, type = '', eatType, path = 'menu' }: { address?: any; callback: (store?: any) => void; type?: string; isDelivery?: boolean; eatType?: TEatType; path?: string }) {
    if (!['mall'].includes(type)) {
      deliveryMobx.setShowModalFlag()
    }
    return modalLayer(AddressEditModal, { info: address, eatType }, 'AddressEditModal').then((res: any) => {
      if (!res) return
      if (type === 'mall') {
        deliveryMobx.setAddress(res, type)
        callback?.(res)
      } else if (type === 'buyTogether') { // buyTogether
        callback?.(res)
      } else {
        const viewAddress = deliveryMobx.verifyAddresses([res])[0] || deliveryMobx.viewAddresses?.find(addr => addr.memberAddressId === res?.memberAddressId)
        /** 开启切换地址，自动切换最近门店功能 */
        const openAutoChangeStoreFormAddress = !!boJudge.checkGrayKey('openAutoChangeStoreFormAddress')
        /** 从成功过来 or 当前地址存在 or 商城 */
        if (!openAutoChangeStoreFormAddress && (res.checkStatus === TCheckAddressStatus.Success || (viewAddress?.inArea && viewAddress?.inCityId))) {
          deliveryMobx.setAddress(viewAddress, type)
          callback?.()
        } else {
          if (viewAddress.memberAddressId === deliveryMobx.address?.memberAddressId) {
            deliveryMobx.resetAddress()
          }
          const store = deliveryMobx.getNearByStore({
            address: viewAddress,
            notStoreId: !openAutoChangeStoreFormAddress ? storeMobx.info.storeId : 0
          }) as IViewStore
          if (store) {
            if (eatType === TEEatType.delivery) {
              deliveryMobx.setAddress(viewAddress, type)
              if (storeMobx.info.storeId !== store.storeId) {
                hasStoreModal(store)
              }
            }
            callback?.(store)
          } else {
            toast({
              message: `${i18n.t('location.noStoreInAddress')},<br/>${i18n.t('location.noStoreInAddress2')}`,
              time: 2000,
              position: 'middle',
              cssClass: 'toastW50'
            })
            callback?.()
          }
        }
      }
    }, () => { })
  }

  /** 校验收货地址，是否有门店在配送范围 */
  static async checkAddressInArea (address: any) {
    const viewAddress = deliveryMobx.verifyAddresses([address])[0]
    if (viewAddress?.inArea && viewAddress?.inCityId) {
      return TCheckAddressStatus.Success
    } else {
      const store = deliveryMobx.getNearByStore({
        address: viewAddress,
        notStoreId: storeMobx.info.storeId
      })
      // if (store) {
      //   return TCheckAddressStatus.Success
      // } else {
      return await modalLayer(AddressTipModal, {
        hasStore: !!store,
        type: !viewAddress?.inArea && !viewAddress?.inCityId ? 'all' : viewAddress?.inArea && !viewAddress?.inCityId ? 'tax' : 'area'
      }, 'addressTipModal').then(() => {
        return TCheckAddressStatus.Skip
      }, () => {
        return TCheckAddressStatus.Cancel
      })
      // }
    }
  }
}

export default DeliveryController
